import { render, staticRenderFns } from "./SpecificationCreateOrDetails.vue?vue&type=template&id=48804a07&"
import script from "./SpecificationCreateOrDetails.vue?vue&type=script&lang=js&"
export * from "./SpecificationCreateOrDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports